import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-4 left-4 right-4 md:left-1/2 md:right-auto md:transform md:-translate-x-1/2 z-50 max-w-md w-auto md:w-full"
}
const _hoisted_2 = { class: "bg-white dark:bg-gray-800 rounded-lg shadow-2xl border border-gray-200 dark:border-gray-700 p-4 flex items-center gap-3 md:gap-4" }
const _hoisted_3 = { class: "flex-shrink-0" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex gap-2 flex-shrink-0" }

import { usePWAInstall } from '@/composables/usePWAInstall'


export default /*@__PURE__*/_defineComponent({
  __name: 'PWAInstallPrompt',
  setup(__props) {

const { showInstallPrompt, isInstalled, installPWA, dismissInstallPrompt } = usePWAInstall()
const publicPath = process.env.BASE_URL || '/portal/'

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "slide-up" }, {
    default: _withCtx(() => [
      (_unref(showInstallPrompt) && !_unref(isInstalled))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: `${_unref(publicPath)}icons/web-app-manifest-192x192.png`,
                  alt: "App Icon",
                  class: "w-10 h-10 md:w-12 md:h-12 rounded-lg"
                }, null, 8, _hoisted_4)
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-1 min-w-0" }, [
                _createElementVNode("h3", { class: "text-sm font-semibold text-gray-900 dark:text-white" }, " Install App "),
                _createElementVNode("p", { class: "text-xs text-gray-600 dark:text-gray-400 mt-0.5 hidden sm:block" }, " Install this app on your device for quick and easy access ")
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(installPWA) && _unref(installPWA)(...args))),
                  class: "px-3 py-2 md:px-4 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium rounded-md transition-colors"
                }, " Install "),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(dismissInstallPrompt) && _unref(dismissInstallPrompt)(...args))),
                  class: "px-2 py-2 md:px-3 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 text-sm transition-colors",
                  "aria-label": "Dismiss"
                }, " ✕ ")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})